import { render, staticRenderFns } from "./UserCreditTab.vue?vue&type=template&id=7529c7bb&"
import script from "./UserCreditTab.vue?vue&type=script&lang=js&"
export * from "./UserCreditTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports